module.exports = "https://trybtryb-legacy.web.app/img/square-outline-desktop.2d3959a3.svg";